import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DataTable } from '../../components/DataTable';
import usePaginationV2 from '../../util/usePaginationV2';
import MasterUserTenantservice from '../../service/MasterServices/MasterUserTenantService';
import MasterTenantModulservice from '../../service/MasterServices/MasterTenantModulService';
import SingleSelection from '../../ui/SingleSelection';
import useMessage from '../../util/useMessage';
import { Delete } from '@mui/icons-material';
import masterTenantservice from '../../service/MasterServices/MasterTenantService';
import SwitchCell from '../../components/SwitchCell';
import { MessageType } from '../../util/Enums';


const MasterUserTenantDialog = ({ open, onClose, selectedKey }) => {

    const { t } = useTranslation();
    const showMessage = useMessage();

    const [tenantModul, setTenantModul] = useState([]);

    const handelaktifSwitchChange = async (item, newCheckedVal) => {
        console.log(item, newCheckedVal);
        const result = await MasterUserTenantservice.update({
            id: item.id,
            aktif: !item.aktif
        });
        DataServiceList.search();
        return true;
    };

    const columns = [

        {
            name: "tenantName",
            label: t('label.tenantName'),
            textAlign: "left",
            searchable: false,
        },
        {
            name: "aktif",
            label: t('label.aktif'),
            textAlign: "center",
            searchable: false,
            passItem: true,
            execute: (item) =>
            (<SwitchCell item={item.aktif}
                checked={item.aktif}
                onClick={(newCheckedVal) => handelaktifSwitchChange(item, newCheckedVal)}
            />)
        },
        {
            sortable: false,
            searchable: false,
            passItem: true,
            textAlign: "Center",
            title: "action",
            execute: (item) => (
                <>
                    <IconButton
                        onClick={() => onDeleteItem(item)}
                        color="error"
                        variant="contained"
                        title={t("rowActions.delete")}
                        size="small">
                        <Delete />
                    </IconButton>
                </>
            ),
        },
    ];





    const DataServiceList = usePaginationV2({
        service: MasterUserTenantservice,
        defaultSearchData: {
            masterUserId: selectedKey ?? 0
        },
        takeAll: true,
        defaultOrderBy: [
            {
                key: "Id",
                value: "Desc"
            }
        ],
        pageColumns: columns,
    });

    useEffect(async () => {
        const { resultObject } = await masterTenantservice.get();
        setTenantModul(resultObject);
        // If selectedKey or open has changed, update the search data
        if (open && selectedKey) {
            DataServiceList.setSearchData({
                masterUserId: selectedKey
            });
        } else {
            DataServiceList.setData([]);
        }

    }, [open, selectedKey]);

    const handleSingleButtonClick = async (selectedObject) => {
        const result = await MasterUserTenantservice.create({
            tenantId: selectedObject.id,
            masterUserId: selectedKey
        });

        if (result && result.isSuccess) {
            showMessage(t('message.created'));
            DataServiceList.search();
        } else {
            showMessage(t('message.tenantAuthType'), MessageType.ERROR);
        }

    };

    const onDeleteItem = async (item) => {
        const result = await MasterUserTenantservice.delete(item.id);

        if (result && result.isSuccess) {
            showMessage(t('message.created'));
            DataServiceList.search();
        }
    }



    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth={"xl"}
            scroll="paper"
        >
            <DialogTitle>
                {t('title.MasterUserTenant')}
            </DialogTitle>

            <DialogContent dividers={true}>
                <SingleSelection
                    items={tenantModul}
                    keyField="id"
                    valueField="id"
                    labelField="name"
                    buttonLabel={t("button.add")}
                    selectLabel={t("rowActions.Select")}
                    onButtonClick={handleSingleButtonClick}
                />
                <DataTable
                    columns={columns}
                    {...DataServiceList}
                //rowActions={RowActions}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">{t('button.close')}</Button>
            </DialogActions>
        </Dialog>
    );

};


export default MasterUserTenantDialog;


